const text = (v) => (typeof v === 'string' ? v : '');

// The house error body read once. code: error_code, else a string reason (its code before error_code
// existed). reason: reason's prose, which was an error object on older apis routes.
export function read_api_error(e) {
  const body = e?.response?.data || {};
  return {
    body,
    code: text(body.error_code) || text(body.reason),
    message: text(body.message),
    reason: text(body.reason) || text(body.reason?.message)
  };
}

// apis answers errors as {message} and/or {reason}; a specific reason wins over message, which some
// routes keep generic ("Unable to update session").
export function api_error_message(e, fallback = 'Some error occured. Please contact dev team.') {
  const { reason, message } = read_api_error(e);
  return reason || message || fallback;
}
